import React from 'react'

const AboutAuth = () => {
  return (
    <div className='auth-container-1'>
        <h1>Join the Stack Overflow community</h1>
        <p>Get unstuck — ask a question</p>
        <p>Unlock new privileges like voting and commenting</p>
        <p>Save your favorite questions, answers, watch tags, and more</p>
        <p>Earn reputation and badges</p>
        <p style={{fontSize:'13px', color:'#666767'}}>Collaborate and share knowledge with a private group for FREE.</p>
        <p style={{fontSize:'13px', color:'#007a76'}}>Get Stack Overflow for Teams free for up to 50 users.</p>
    </div>
  )
}

export default AboutAuth